import React from 'react';
import { bool, string, shape, number, arrayOf, func } from 'prop-types';

import coord from 'propTypes/coord';
import locationShape from 'propTypes/locationShape';
import segmentStatus from 'propTypes/segmentStatus';

import RouteSegment from 'components/Map/MapComponents/RouteSegment';

export default function Route({ route, onEnter, onLeave, onSelect, isSelected, isHovered }) {
  // eslint-disable-next-line global-require
  const PriorityFeatureGroup = require('components/Map/MapComponents/PriorityFeatureGroup').default;

  const { id: routeId, priority } = route;
  const isActive = Boolean(isSelected || isHovered);

  return (
    <PriorityFeatureGroup
      priority={priority}
      onMouseover={onEnter}
      onMouseout={onLeave}
      onClick={onSelect}
    >
      {route.segments.map(segment =>
        <RouteSegment
          key={`RouteSegment-${routeId}-${segment.id}${isActive ? '-active' : ''}`}
          segment={segment}
          route={{
            status: route.status,
            from: route.from,
            to: route.to,
            liveTravelTime: route.liveTravelTime,
            distance: route.distance,
          }}
          isSelected={isSelected}
          isActive={isActive}
        />
      )}
    </PriorityFeatureGroup>
  );
}

Route.propTypes = {
  route: shape({
    id: string,
    name: string,
    priority: number,
    segments: arrayOf(
      shape({
        id: string,
        from: locationShape,
        to: locationShape,
        path: arrayOf(coord),
        liveTravelTime: number,
        status: segmentStatus,
      })
    ),
  }).isRequired,
  isSelected: bool,
  isHovered: bool,
  onSelect: func.isRequired,
  onEnter: func.isRequired,
  onLeave: func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/Map/MapComponents/Route/index.js